import { useEffect, useState } from 'react'

export function useSmoothLoading(isLoading: boolean, delay: number = 300): boolean {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (isLoading) {
            setVisible(true)
        } else {
            const timeout: NodeJS.Timeout = setTimeout((): void => setVisible(false), delay)
            return (): void => clearTimeout(timeout)
        }
    }, [isLoading, delay])

    return visible
}
